import { apiRequest } from "@core/services/api/apiRequest";

export type UpdateProfileSettingsPayload = {
  /** Email notifications enabled */
  is_email_notifications_enabled?: boolean;
  /** Text notifications enabled */
  is_text_notifications_enabled?: boolean;
  /** Timezone */
  timezone?: string;
  /** Resume/CV media ID */
  resume_media_id?: string;
  /** User role (required for profile update) */
  role?: string;
};

export type UpdateProfileSettingsResponse = {
  user_data: Record<string, unknown>;
};

/**
 * Updates profile settings via API with partial data.
 * Use this for settings forms that update individual fields.
 */
export async function updateProfileSettings(
  payload: UpdateProfileSettingsPayload
): Promise<UpdateProfileSettingsResponse> {
  const response = (await apiRequest(
    `/profile/`,
    "POST",
    payload
  )) as UpdateProfileSettingsResponse;

  return response;
}

export default updateProfileSettings;
